export const SOCIAL_AUTH_REQUEST = 'SOCIAL_AUTH_REQUEST';
export const SOCIAL_AUTH_FAILURE = 'SOCIAL_AUTH_FAILURE';
export const SOCIAL_AUTH_SUCCESS_DATA = 'SOCIAL_AUTH_SUCCESS_DATA';
export const SOCIAL_AUTH_SUCCESS_TOKEN = 'SOCIAL_AUTH_SUCCESS_TOKEN';
